import Swal from 'sweetalert2/dist/sweetalert2.js'
export const product = {
  data(){
    return {
      hasPrice: true
    }
  },
  methods: {
    checkPrice() {
      if (this.item.price) {
        return {
          price: parseInt(this.item.price),
          unit: 'шт',
          vol: ''
        }
      } else {
        return false;
      }
    },
    checkHasPrice(){
      if(this.item.price || (this.item.props.length > 0 && this.item.props[0].price)){
        console.log('Есть цена');
        this.hasPrice = true;
      } else {
        console.log('Нет цена');
        this.hasPrice = false;
      }
    },
    notify() {
      let unit;
      switch (this.item.currentProp.unit) {
        case 'литр':
          unit = '(' + this.item.currentProp.vol + ' мл)';
          break;
        case 'шт':
          unit = '';
          break;
      }
      let str = `Отлично! Товар ${this.item.title} ${unit } добавлен в корзину`;
      Swal.fire({
        title: 'Товар добавлен',
        text: str,
        type: 'success',
        confirmButtonText: 'Хорошо'
      })
    }
  }
};


// WEBPACK FOOTER //
// ./themes/polza/src/js/components/mixins/product.js